// 住所検索エラーポップアップ
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Link from './Link';

interface ButtonStatus {
  label: string;
  variant: string;
  handleClick: () => void;
}

interface Props {
  text: string;
  link_label: string;
  link_anchor: string;
  isViewLink?: boolean;
  isShow: boolean;
  toggleClose: React.MouseEventHandler;
  button: ButtonStatus;
}

const SearchAddressError: React.FC<Props> = ({
  text,
  link_label,
  link_anchor,
  isViewLink,
  isShow,
  toggleClose,
  button,
}) => {
  return (
    <Modal
      size="lg"
      show={isShow}
      onHide={toggleClose}
      animation={false}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton />
      <Modal.Body className="pt-0">
        <div className="p-lead popup_text">{text}</div>
        {isViewLink && (
          <div className="p-lead popup_text">
            <Link display_name={link_label} anchor={link_anchor} />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="btn-area one-btn">
          <Button variant={button.variant} onClick={button.handleClick}>
            {button.label}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SearchAddressError;
